import axios from 'axios';
import axiosClient from './axiosClient';
import { unwrapApiResponse } from '../utils/unwrapApiResponse';

const apiBase = process.env.REACT_APP_API_BASE_URL;

const unwrapPublicResponse = (response) => {
  const body = response.data;

  if (!body?.success) {
    const error = new Error(body?.message || 'Request failed');
    error.errors = body?.errors || [];
    error.status = response.status;
    throw error;
  }

  return body.data;
};

export const submitAccountApplication = async (formData, onUploadProgress) => {
  const response = await axios.post(`${apiBase}/api/account-submissions`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });

  return unwrapPublicResponse(response);
};

export const getAccountSubmissions = async () => {
  const response = await axiosClient.get('/api/admin/account-submissions');
  return unwrapApiResponse(response);
};

export const getAccountSubmissionById = async (id) => {
  const response = await axiosClient.get(`/api/admin/account-submissions/${id}`);
  return unwrapApiResponse(response);
};

export const deleteAccountSubmission = async (id) => {
  const response = await axiosClient.delete(`/api/admin/account-submissions/${id}`);
  return unwrapApiResponse(response);
};
